import React from 'react'
import { l } from '@manychat/manyui'

export const WAMarketingMessagesUnified = () => {
  return (
    <span>
      {l.translate(
        'All WhatsApp Marketing and Marketing Lite templates are now under a single Marketing category.',
      )}
    </span>
  )
}
